import type { ViewScopeQueryKeys } from "@web/features/Views/defaultViewQuery";

/** Query param for report topic scope (will become `reportList` in a later epic). */
export const REPORT_VIEW_TOPIC_QUERY_KEY = "topic";

export const REPORT_VIEW_SCOPE_QUERY = {
  topic: REPORT_VIEW_TOPIC_QUERY_KEY,
  sort: "sort",
  property: "property",
} as const;

export type ReportViewScopeQueryKey = keyof typeof REPORT_VIEW_SCOPE_QUERY;

/** The query parameter of each report view scope type (`ViewScopeTypeEnum` in the API). */
export const REPORT_VIEW_SCOPE_QUERY_BY_TYPE = {
  reportList: REPORT_VIEW_SCOPE_QUERY.topic,
  sort: REPORT_VIEW_SCOPE_QUERY.sort,
  property: REPORT_VIEW_SCOPE_QUERY.property,
} as const satisfies ViewScopeQueryKeys;

export interface ReportViewScopeParams {
  topic: string | null
  sort: string | null
  property: string | null
}

export function parseReportViewScopeFromQuery(query: Record<string, unknown>): ReportViewScopeParams {
  function one(key: string): string | null {
    const raw = query[key];
    const value = Array.isArray(raw) ? raw[0] : raw;
    return typeof value === "string" && value !== "" ? value : null;
  }

  return {
    topic: one(REPORT_VIEW_SCOPE_QUERY.topic),
    sort: one(REPORT_VIEW_SCOPE_QUERY.sort),
    property: one(REPORT_VIEW_SCOPE_QUERY.property),
  };
}

/** Opens the per-object list without an object chosen yet: the per-object section asks for one. */
export const REPORT_PROPERTY_BROWSE_QUERY_KEY = "propertyBrowse";

export function isReportPropertyBrowseQuery(query: Record<string, unknown>): boolean {
  const raw = query[REPORT_PROPERTY_BROWSE_QUERY_KEY];
  const value = Array.isArray(raw) ? raw[0] : raw;
  return value === "1" || value === "true";
}
